import { render, staticRenderFns } from "./leadMessage.vue?vue&type=template&id=3a40db48&lang=pug"
import script from "./leadMessage.vue?vue&type=script&lang=js"
export * from "./leadMessage.vue?vue&type=script&lang=js"
import style0 from "./leadMessage.vue?vue&type=style&index=0&id=3a40db48&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports